import { render, staticRenderFns } from "./CustomerType.vue?vue&type=template&id=a937dda0&scoped=true"
import script from "./CustomerType.vue?vue&type=script&lang=js"
export * from "./CustomerType.vue?vue&type=script&lang=js"
import style0 from "./CustomerType.vue?vue&type=style&index=0&id=a937dda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a937dda0",
  null
  
)

export default component.exports